import { createContext } from "react";

export const ExamCreatorContext = createContext();
